// src/api/axiosInstance.js
import axios from 'axios'

const axiosInstance = axios.create({
  baseURL: 'https://kpms.kebea.in/api/v1',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
    'x-aample-api-key': '4Z9uAfiy4axzLtL268NoGPuLb7Ga8H'
  }
})

export default axiosInstance
